<div class="row d-none d-md-flex">
  <div class="col-12 col-sm-5 col-md-12 col-lg-4 font-sm">
    <div>{{ outlet.address }}</div>
    <div>{{ outlet.postNumber }} {{ outlet.cityName }}</div>
    <button class="btn btn-link ps-0 fw-normal font-md"
            (click)="onMapRequested.emit(outlet)"
            [translate]="'common.showOnMap'">
    </button>
  </div>

  <!-- TODO: move open hours to a separate component and do open hours generation inside not in delivery.service -->
  <div class="col-12 col-sm-7 col-md-12 col-lg-8 font-sm mt-xs-max-4">
    <ng-container *ngFor="let days of formattedSchedule">
      <div class="d-flex" *ngIf="!days.isClosed">
        <div class="outlet-days-label">{{ days.days }}</div>

        <div class="flex-grow-1">
          {{ days.begin + ' - ' + days.end }}
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="d-block d-md-none font-sm">
  <button class="btn btn-link p-0 fw-normal font-md"
          (click)="onMapRequested.emit(outlet)"
          [translate]="'common.showOnMap'">
  </button>
</div>

<ui-message-custom class="font-md d-block my-3 message-block"
                   *ngIf="outlet.notesForCustomer">
  {{ outlet.notesForCustomer }}
</ui-message-custom>

<product-availability-notice *ngIf="availableProductTypes?.length"
                             [availableProductTypes]="availableProductTypes">
</product-availability-notice>

<daily-stock-sold-out-notice
  class="d-block my-3"
  [productTypes]="dailyStockSoldOutProductTypes"
></daily-stock-sold-out-notice>

<pickup-custom-opening-time
  *ngIf="scheduleOverrides?.length > 0"
  class="d-block my-3"
  [specialOpeningTimes]="scheduleOverrides"
></pickup-custom-opening-time>

<sold-out-msg
  class="d-block my-3"
  *ngIf="fullCapacityDays?.length"
  [fullCapacityDays]="fullCapacityDays"
></sold-out-msg>

<form novalidate #f="ngForm" class="outlet-form">
  <ui-datetime-skeleton [loading]="skeletonPromise">
    <pickup-asap
      *ngIf="asapTime()"
      class="d-block mt-4 mb-2 mb-md-0"
      [time]="asapTime()"
      [nextBtnView]="nextBtnView"
      (confirm)="selectAsapTime()"
    ></pickup-asap>

    <div class="row g-0 mt-md-min-4">
      <div *ngIf="!asapTime()"
           class="col-12 mb-2 d-md-none fw-bold font-md"
           [translate]="'orderProcess.delivery.deliveryForms.whenDoYouWantToPickUp'">
        When do you want to pick it up?
      </div>

      <div class="col-6 col-lg-4 pe-2 pr-xs-max-1">
        <label *ngIf="!asapTime()"
               #datePickerLabel
               class="text-bold font-sm d-none d-md-block"
               [translate]="'orderProcess.delivery.deliveryForms.chooseDate'">
        </label>

        <ui-delivery-datepicker
          [calendar]="calendar()"
          [disabled]="isCalendarLoading()"
          [placement]="'bottom-left'"
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="selectedDate"
          (onContextInit)="contextInit($event)"
          (ngModelChange)="changeDate($event)"
          (onMonthNavigate)="onMonthNavigate($event)"
        ></ui-delivery-datepicker>
      </div>

      <div class="col-6 col-lg-4 ps-2 pl-xs-max-1">
        <label *ngIf="!asapTime()"
               class="text-bold font-sm d-none d-md-block"
               [translate]="'orderProcess.delivery.deliveryForms.chooseTime'">
        </label>

        <div class="dropdown-container dropdown-item-slim">
          <div ngbDropdown role="group"
               #rangeDropDown="ngbDropdown"
               [placement]="'bottom'">
            <button class="btn btn-select fw-normal"
                    [class.attention-select]="!selectedTimeRange && timeRanges"
                    [disabled]="!timeRanges"
                    ngbDropdownToggle>
              {{ selectedTimeRange || ('common.timePlaceholder' | translate) }}
            </button>

            <div class="dropdown-menu" ngbDropdownMenu>
              <button class="dropdown-item w-100 fw-normal"
                      (click)="changeRange(range)"
                      [class.selected]="selectedTimeRange===range"
                      *ngFor="let range of timeRanges">{{ range }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4 align-self-end ps-3 pl-md-max-0 pickup-next-btn-wrap"
           [class.mt-lg-max-3]="!isAsapAvailable"
           [class.mt-md-max-3]="isAsapAvailable">
        <button class="btn {{nextBtnView}} btn-mobile-full-width pickup-next-btn"
                type="button"
                [disabled]="!selectedDate || !selectedTimeRange || !f.valid || (isWaitUntilOutletSelect && !isOutletSelectedFlag())"
                (click)="onNext.emit()">
          <span [translate]="nextBtnTextKey"></span>
        </button>
      </div>
    </div>
  </ui-datetime-skeleton>
</form>
